import FormattedMessage from 'I18n/components/FormattedMessage';
import { useAssetStatus, useStartLessonProgress, useStartTrackProgress } from '../userProgressQueries';
import { useHistory } from 'react-router-dom';
import { getListingUrl } from '../../../utils/RoutingUtils';
import Raven from 'raven-js';
// @ts-expect-error Could not find declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import { getShortContentUrl } from '../../shortContent/shortContentRouting';
import { useShortStatus } from '../../shortContent/shortContentHooks';
import getLang from 'academy-common-lib/utils/getLang';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
const WideUIButton = props => {
  const {
    isMobile,
    isNotMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    as: "span",
    display: "inline-block",
    inlineSize: isMobile ? '100%' : undefined,
    maxInlineSize: "600px",
    minInlineSize: isNotMobile ? '200px' : undefined,
    children: /*#__PURE__*/_jsx(Button, Object.assign({
      block: true
    }, props))
  });
};
const usePlaylistId = () => {
  const [[playlistId]] = useSearchParam('playlistId');
  return playlistId;
};
export const EnrollTrackButton = ({
  language,
  id,
  onEnroll
}) => {
  const history = useHistory();
  const playlistId = usePlaylistId();
  const {
    status
  } = useAssetStatus({
    type: 'TRACK',
    id
  });
  const [startTrackProgress, {
    startTrackProgressLoading
  }] = useStartTrackProgress({
    trackId: id,
    language: (language === null || language === void 0 ? void 0 : language.toLowerCase()) || getLang(),
    playlistId
  });
  const handleEnroll = () => {
    startTrackProgress().catch(e => {
      Raven.captureException(e);
    });
    history.push(getListingUrl({
      type: 'TRACK',
      id,
      language,
      isStarted: true,
      playlistId
    }).fullUrl);
    onEnroll();
  };
  return /*#__PURE__*/_jsx(WideUIButton, {
    "data-test-id": "overview-enroll-button",
    disabled: startTrackProgressLoading,
    onClick: handleEnroll,
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.overviewModal.mainAction.track.${status}`
    })
  });
};
export const EnrollLessonButton = ({
  language,
  id,
  onEnroll,
  use = 'primary'
}) => {
  const history = useHistory();
  const playlistId = usePlaylistId();
  const {
    status
  } = useAssetStatus({
    type: 'LESSON',
    id
  });
  const [startLessonProgress, {
    startLessonProgressLoading
  }] = useStartLessonProgress({
    lessonId: id,
    language: (language === null || language === void 0 ? void 0 : language.toLowerCase()) || getLang(),
    playlistId
  });
  const handleEnroll = () => {
    startLessonProgress().catch(e => {
      Raven.captureException(e);
    });
    history.push(getListingUrl({
      type: 'LESSON',
      id,
      language,
      isStarted: true,
      playlistId
    }).fullUrl);
    onEnroll();
  };
  return /*#__PURE__*/_jsx(WideUIButton, {
    "data-test-id": "overview-enroll-button",
    disabled: startLessonProgressLoading,
    onClick: handleEnroll,
    use: use,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.overviewModal.mainAction.lesson.${status}`
    })
  });
};
export const EnrollShortButton = ({
  id,
  onEnroll
}) => {
  const history = useHistory();
  const playlistId = usePlaylistId();
  const {
    status
  } = useShortStatus(id);
  const handleEnroll = () => {
    history.push(getShortContentUrl({
      shortId: id,
      playlistId
    }));
    onEnroll();
  };
  return /*#__PURE__*/_jsx(WideUIButton, {
    "data-test-id": "overview-enroll-button",
    onClick: handleEnroll,
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.overviewModal.mainAction.short.${status}`
    })
  });
};